var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1035_2067)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 0C6.72867 0 0 6.72867 0 15C0 23.2713 6.72867 30 15 30C23.2713 30 30 23.2713 30 15C30 6.72867 23.2713 0 15 0Z",
    fill: "#F44336"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5235 18.7564C21.0122 19.2453 21.0122 20.0351 20.5235 20.524C20.2798 20.7678 19.9598 20.8902 19.6396 20.8902C19.3196 20.8902 18.9996 20.7678 18.7559 20.524L14.9997 16.7676L11.2435 20.524C10.9998 20.7678 10.6798 20.8902 10.3598 20.8902C10.0396 20.8902 9.71963 20.7678 9.47587 20.524C8.98721 20.0351 8.98721 19.2453 9.47587 18.7564L13.2323 15.0002L9.47587 11.244C8.98721 10.7551 8.98721 9.96525 9.47587 9.47636C9.96476 8.9877 10.7546 8.9877 11.2435 9.47636L14.9997 13.2328L18.7559 9.47636C19.2448 8.9877 20.0346 8.9877 20.5235 9.47636C21.0122 9.96525 21.0122 10.7551 20.5235 11.244L16.7671 15.0002L20.5235 18.7564Z",
    fill: "#FAFAFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1035_2067"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.172f39ba0f122fdedd376ed80c8a9644.svg";
export { ForwardRef as ReactComponent };